import { Button, DatePicker, Select, Space } from "antd";
import { ContentTopBar } from "components";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import timezone from "dayjs/plugin/timezone";
import GraphClientsInfo from "features/dashboard/components/graph/graph-view";
import { FacilitySelect } from "features/facilities/components";
import { useState } from "react";

dayjs.extend(customParseFormat);
dayjs.extend(timezone);

const { RangePicker } = DatePicker;

export const DashBoardFacilityView = () => {
  const today = dayjs();
  const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs] | any>([
    today,
    today,
  ]);
  const [selectedFacilityId, setSelectedFacilityId] = useState<any>(null);
  const [selectedMonth, setSelectedMonth] = useState<string | null>(
    today.format("MMM")
  );
  const [selectedYear, setSelectedYear] = useState<number>(today.year());
  const [appliedFilters, setAppliedFilters] = useState<{
    selectedMonth: string | null;
    selectedYear: number;
    dateRange: [dayjs.Dayjs | null, dayjs.Dayjs | null];
    facilityId: string | null;
  }>({
    selectedMonth: today.format("MMM"),
    selectedYear: today.year(),
    dateRange,
    facilityId: null,
  });

  const currentYear = dayjs().year();

  const months = [
    { label: "All Month", value: null },
    ...dayjs.monthsShort().map((m) => ({ label: m, value: m })),
  ];

  const years = Array.from({ length: 16 }, (_, i) => ({
    label: (currentYear - 10 + i).toString(),
    value: currentYear - 10 + i,
  }));

  const resetFilters = () => {
    const today1 = dayjs();
    const defaultRange: [dayjs.Dayjs, dayjs.Dayjs] = [today1, today1];
    setSelectedMonth(today1.format("MMM"));
    setSelectedYear(today1.year());
    setDateRange(defaultRange);
    setSelectedFacilityId(null);
    setAppliedFilters({
      selectedMonth: today1.format("MMM"),
      selectedYear: today1.year(),
      dateRange: defaultRange,
      facilityId: null,
    });
  };

  return (
    <div className="facily_head">
      <ContentTopBar title="Facilities" />

      <Space style={{ marginBottom: 16 }} className="filter_srch">
        <FacilitySelect
          companyId={""}
          className="filter"
          placeholder="All facilites"
          value={selectedFacilityId}
          onChange={(value) => setSelectedFacilityId(value || null)}
        />
        <Select
          options={months}
          value={selectedMonth}
          onChange={(value) => {
            setSelectedMonth(value);
            if (value !== null) {
              setDateRange(null); // Clear range picker when selecting a specific month
            }
          }}
          style={{ width: 120 }}
          placeholder="Select Month"
          allowClear={true}
        />

        <Select
          options={years}
          value={selectedYear}
          // onChange={(value) => setSelectedYear(value)}
          onChange={(value) => {
            setSelectedYear(value);
            if (value !== null) {
              setDateRange(null); // Clear range picker when selecting a specific year
            }
          }}
          style={{ width: 120 }}
          placeholder="Select Year"
        />

        <RangePicker
          value={dateRange}
          onChange={(dates) =>
            setDateRange(dates as [dayjs.Dayjs, dayjs.Dayjs])
          }
          allowClear={true}
          disabled={selectedMonth === null} // disable range picker if "All" selected
        />

        <div className="filt_btn" style={{ display: "flex", gap: "10px" }}>
          <Button
            type="primary"
            onClick={() =>
              setAppliedFilters({
                selectedMonth,
                selectedYear,
                dateRange,
                facilityId: selectedFacilityId,
              })
            }
          >
            Filter
          </Button>

          <Button onClick={resetFilters}>Cancel</Button>
        </div>
      </Space>

      <GraphClientsInfo
        selectedMonth={appliedFilters.selectedMonth}
        selectedYear={appliedFilters.selectedYear}
        dateRange={appliedFilters.dateRange}
        facilityId={appliedFilters.facilityId}
      />
    </div>
  );
};
